import styled from 'styled-components';

export const Container = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 10px;
`;

export const Label = styled.div`
  font-weight: 400;
  font-size: 12px;
`;
